import type { AgentManifest } from '@indipia/shared';
import { manifest as photoOrganizer } from '@indipia/agents-photo-organizer';
import { manifest as portfolio } from '@indipia/agents-portfolio';
import { manifest as scheduler } from '@indipia/agents-scheduler';
import { manifest as workLog } from '@indipia/agents-work-log';
import { manifest as billing } from '@indipia/agents-billing';

// 현 단계 노출 에이전트: 인디포토 / 인디포트폴리오 / 인디공사현황(A02) / 인디플래너(E01) / 구독결제(G01) (5종)
// 나머지 에이전트(카톡분석기·메모정리기·자재소요량·견적서작성기·캘린더·창호견적·창호실측)는
// 담당 그룹 구현 시점에 본 registry 에 다시 등록한다. (manifest·라우트는 각 패키지에 보존)
//
// DB agentId 기준: photo-organizer(A01,1) / work-log(A02,2) / scheduler(E01,8) / billing(G01, numericAgentId 미정 — Member 팀 확정 필요, 2026-09-07 코드 G01로 확정)
function withMenu(manifest: AgentManifest, label: string, order: number): AgentManifest {
  return {
    ...manifest,
    menuItems: manifest.menuItems.map((m) => ({ ...m, label, order })),
  };
}

export const AGENT_REGISTRY: AgentManifest[] = [
  withMenu(photoOrganizer, '인디포토', 10),
  withMenu(portfolio, '인디포트폴리오', 15), // A03, numericAgentId=11
  withMenu(workLog, '인디공사현황', 20),    // A02, numericAgentId=2
  withMenu(scheduler, '인디플래너', 30), // E01, numericAgentId=8
  withMenu(billing, '구독결제', 90), // G01(UTIL, 2026-09-07 확정), numericAgentId 미정 — Member 팀 확정 후 menu-config.ts 값 갱신 필요
];

export const ALL_ROUTES = AGENT_REGISTRY.flatMap((a) => a.routes);
export const ALL_SHARE_ROUTES = AGENT_REGISTRY.flatMap((a) => a.shareRoutes ?? []); // 외부공유 수신자 뷰어 (F-04 §7, 공개 영역)
export const ALL_MENU = AGENT_REGISTRY.flatMap((a) => a.menuItems);
